const config = {
  appId: 'com.gfc.flash.archetype',
  appName: 'Archetype',
  appVersion: '1.0.0-dev',
  electron: {
    // Custom scheme for your app to be served on in the electron window.
    customUrlScheme: '',
    // Switch on/off whether or not to use deeplinking in your app.
    deepLinkingEnabled: true,
    // Custom protocol to be used with deeplinking for your app.
    deepLinkingCustomProtocol: '',
    // Switch on/off a tray icon and menu, which is customizable in the app.
    trayIconAndMenuEnabled: false,
    // Switch on/off whether or not a splashscreen will be used.
    splashScreenEnabled: false,
    // Custom image name in the electron/assets folder to use as splash image (.gif included)
    splashScreenImageName: 'splash.png',
    // Switch on/off if the main window should be hidden until brought to the front by the tray menu, etc.
    hideMainWindowOnLaunch: false,
  },
  plugins: {
    SplashScreen: {
      launchShowDuration: 0,
      launchAutoHide: true,
      showSpinner: false,
    },
    Keyboard: {
      resizeOnFullScreen: true,
    },
    PluginNativeBiometric: {
      server: 'com.gfc.flash.archetype',
    },
    PluginNativeSocialLogin: {
      providers: {
        google: true,
        facebook: true,
        apple: false,
        twitter: true,
      },
    },
    CapacitorHttp: {
      enabled: true,
    },
  },
  webDir: 'www',
};

export default config;
